import { render, staticRenderFns } from "./StreamStatistics.vue?vue&type=template&id=644dbea0&scoped=true&"
import script from "./StreamStatistics.vue?vue&type=script&lang=js&"
export * from "./StreamStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StreamStatistics.vue?vue&type=style&index=0&id=644dbea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644dbea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644dbea0')) {
      api.createRecord('644dbea0', component.options)
    } else {
      api.reload('644dbea0', component.options)
    }
    module.hot.accept("./StreamStatistics.vue?vue&type=template&id=644dbea0&scoped=true&", function () {
      api.rerender('644dbea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/item/StreamStatistics.vue"
export default component.exports